import axios from "axios";
import { GetAllGGNotificationMemberDTO, GetAllGGNotificationMemberFiltersDTO, GGNotificationMemberDTO } from "./dto";
import { GGNotificationMemberService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";

export class GGNotificationMemberServiceImpl implements GGNotificationMemberService {

    public CreateGGNotificationMember(data: GGNotificationMemberDTO): Promise<void> {
        return axios.post("/api/gg-notification-member",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteGGNotificationMember(id: string): Promise<void> {
        return axios.delete("/api/gg-notification-member/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllGGNotificationMember(filters: GetAllGGNotificationMemberFiltersDTO): Promise<GetAllGGNotificationMemberDTO> {
        return axios.get("/api/gg-notification-member", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                ggNotificationId: filters.ggNotificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetGGNotificationMemberById(id: string): Promise<GGNotificationMemberDTO> {
        return axios.get("/api/gg-notification-member/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}